import { CompanySpecificService, Contract, ContractCompanySpecificService, ContractLight } from "@/types";
import { CreateOrderFromContractValues } from "@/components/organisms/CreateOrderFromContract/index";

export const createOrderFromContractPlaceholder = (
  companyId?: number,
  userId?: number,
  contract?: ContractLight
): Partial<CreateOrderFromContractValues> | null => {
  if (!companyId || !userId || !contract) return null;
  return {
    companyId: companyId,
    userId: userId,
    amount: 0,
    unit: contract.contractProduct?.priceUnit.id ?? 1,
    orderAddress: null,
    contractId: contract.id,
    boxtypeId: 1,
    orderCurrency: contract.contractProduct?.currencyType,
    orderNeedsApproval: !contract.automaticSalesApproval,
    companySpecificServices: [],
    estimatedDelivery: new Date(),
    created: new Date(),
    batchNumber: "",
  };
};

export const getMappedServicesWithContractPricing = (
  companySpecificServicesData: CompanySpecificService[] | undefined,
  fullContract: Contract
): ContractCompanySpecificService[] => {
  if (!companySpecificServicesData || !fullContract?.companySpecificServices) return [];

  return companySpecificServicesData
    .filter(
      (service) =>
        service.priceUnit.code === "PPO" &&
        fullContract.companySpecificServices.some((s) => s.companySpecificServiceId === service.id)
    )
    .map((service) => {
      const contractService = fullContract.companySpecificServices.find(
        (s) => s.companySpecificServiceId === service.id
      );

      return {
        companySpecificServiceId: service.id,
        price: contractService?.price || service.price,
        currencyType: service.currency,
      };
    });
};


export const determineIfEstimatedDeliveryIsRequired = (orderPlanning: boolean, automaticProccessing: boolean) => {
  return orderPlanning || automaticProccessing;
}